export const showSearchForm = () => {
    
};

export const showNavBar = () => {
    $('#nav-open-close').click(function() {

      if( $('#nav-open-close').hasClass('open') ){
        //cerrar menu
        $('#header').removeClass('menu-opened');
        $('.header__desplegable').removeClass('appear');
        $('#nav-open-close').removeClass('open');
      } else {
       	//abrir
        $('#header').addClass('menu-opened');
        $('#nav-open-close').addClass('open');
        $('.header__desplegable').addClass('appear');

      }
    });
};